var CommonEventIds;
(function (CommonEventIds) {
    CommonEventIds[CommonEventIds["BrowserExtensionsUnhandledError"] = 9997] = "BrowserExtensionsUnhandledError";
    CommonEventIds[CommonEventIds["UnstructuredError"] = 9998] = "UnstructuredError";
    CommonEventIds[CommonEventIds["UnhandledError"] = 9999] = "UnhandledError";
})(CommonEventIds || (CommonEventIds = {}));

export { CommonEventIds };
